import { useState } from 'react'
import * as actions from '@actions/user'
import { useQuery } from '@tanstack/react-query'
import AppContent from '@/app/AppContent'

const AppWithUser = () => {
    
    const [hasFetchedUser, setHasFetchedUser] = useState(null)
    
    const {
        error: userError,
        isLoading: userIsLoading,
    } = useQuery({
        queryKey: ['AppWithUser#user'],
        queryFn: async () => {
            
            let res = null
            
            try {
                res = await actions.fetchProfile()
            } catch (e) {
                console.error('AppWithUser#query failed to fetch user profile', e)
            }
            
            setHasFetchedUser(true)
            return res
            
        },
        enabled: !hasFetchedUser,
        retry: 0,
    })
    
    if (userError) return (
        <div className="absolute inset-0 flex flex-col justify-center">
            <p>An unknown error occurred when fetching your profile.</p>
            <p>Please try again.</p>
        </div>
    )
    
    if (userIsLoading) return (
        <div className="absolute inset-0 flex flex-col justify-center">
            <span className="loading loading-spinner" />
        </div>
    )
    
    return hasFetchedUser ? <AppContent /> : null
    
}

export default AppWithUser
